import { Icon, Avatar, Divider, ListItemButton, Drawer, List, ListItemText, ListItemIcon, useTheme, useMediaQuery } from '@mui/material';

import MDBox from '../../../components/MDBox';
import React from 'react';

import { NavLink, useNavigate } from 'react-router-dom';

import cimbeoLogo from '../../../assets/images/small-logos/cimbeo_logo.png'

import MDTypography from '../../../components/MDTypography';
import MDButton from '../../../components/MDButton';
function ProjectsNavBar() {
    const navigate = useNavigate();
    const theme = useTheme();
    const isXl = useMediaQuery(theme.breakpoints.up('xl'));

    if (!isXl) return null;

    return (
        <Drawer 
            sx={{
                width: 240,
                flexShrink: 0,
                justifyContent: "center",
                alignContent: "center",
                display: "flex",
                boxSizing: 'border-box',
                flexDirection: "column",
                '& .MuiListItemText-primary': {
                    fontSize: 14,  
                    color: "#000000"
                },
                '& .MuiListItemButton-root': {
                    display: "flex",
                    flexDirection: "coulmn",
                    alignItems:"center",
                },
                '& .Mui-selected': {
                    '&:hover': {
                        backgroundColor: "#b4914b !important"
                    },
                    backgroundColor: "#c2a66e !important",    
                    '& .MuiListItemText-primary': {
                        color: "#FFFFFF"
                    },
                },
                '& .MuiDrawer-paper': {
                    backgroundColor: ({ palette: { secondary } }) => secondary.main,
                }
        }}
            classes={{
                paper: {
                    width: 240,
                    alignItems:"center",
                    justifyContent: "center",
                }
            }}
            variant="permanent" anchor="left">
            <MDButton color="slate_gray" onClick={() => navigate("/home")}>
                <MDBox sx={{ display: 'flex', alignItems: 'center', pr: 1, pt: 1}}>
                    <Avatar sx={{width: 44, height: 44, marginRight: 2}}
                        alt=""
                        src={cimbeoLogo}/>
                    <MDTypography variant="h2">CIMBEO</MDTypography>
                </MDBox>
            </MDButton>
            <Divider sx={{m: 1}}/>
            <List ml={1}>
                <NavLink to="/account-management">
                    {({isActive}) => (<ListItemButton selected={isActive}>
                        <ListItemIcon>
                            <Icon>radio_button_unchecked</Icon>
                        </ListItemIcon> 
                        <ListItemText primary="My Account"/>
                    </ListItemButton>)}
                </NavLink>
                <NavLink to="/admin">
                    {({isActive}) => (<ListItemButton selected={isActive}>
                        <ListItemIcon>
                            <Icon>radio_button_unchecked</Icon>
                        </ListItemIcon> 
                        <ListItemText primary="Admin"/>
                    </ListItemButton>)}
                </NavLink>
                <NavLink to="/artifact-ingestion">
                    {({isActive}) => (<ListItemButton selected={isActive}>
                        <ListItemIcon>
                            <Icon>radio_button_unchecked</Icon>
                        </ListItemIcon> 
                        <ListItemText primary="Artifact Ingestion"/>
                    </ListItemButton>)}
                </NavLink>
                <NavLink to="/projects">
                {({isActive}) => (
                    <ListItemButton selected={isActive}>
                        <ListItemIcon>
                            <Icon>radio_button_unchecked</Icon>
                        </ListItemIcon> 
                        <ListItemText primary="Projects"/>
                    </ListItemButton>
                )}
                </NavLink>
            </List>
        </Drawer>
    )
}

export default ProjectsNavBar;